<template>
  <div
    class="flex flex-col flex-grow w-full mx-auto md:w-630px"
    role="alert"
    aria-live="assertive"
  >
    <div class="px-6 py-12 mt-12 text-center bg-white">
      <svg-offline
        width="50"
        height="50"
        class="mx-auto mb-4"
        aria-hidden="true"
        role="img"
      ></svg-offline>
      <h3
        class="text-3xl font-bold mt-6"
        id="offline-status"
      >
        Jarvis Scheduler seems to be offline
      </h3>
      <p
        class="mt-2"
        aria-describedby="offline-status"
      >Please reload this page after a few minutes</p>
      <button-link
        href="/"
        class="inline-flex items-center justify-center px-6 py-2 mx-auto border-gray-500 mt-6"
        @click.prevent="reload"
        aria-label="Reload page to try again"
      >
        Reload
      </button-link>
    </div>
  </div>
</template>

<script>
import SvgOffline from "@/components/Svg/SvgOffline";
import ButtonLink from "@/components/Button/ButtonLink";

export default {
  components: {
    SvgOffline,
    ButtonLink,
  },
  methods: {
    reload() {
      if (!window || !document) return;
      document.location.reload();
    },
  },
  created() {
    this.$store.commit("fieldUpdate", {
      key: "isError",
      value: true,
    });

    // Announce offline status to screen readers
    this.$nextTick(() => {
      document.title = "Jarvis Scheduler - Offline";
    });
  },
  destroyed() {
    this.$store.commit("fieldUpdate", {
      key: "isError",
      value: false,
    });
  },
};
</script>

<style scoped>
@media (min-width: 768px) {
  .md\:w-630px {
    width: 640px;
  }
}
</style>
